import type { CommonAPITeamIdFilter, CommonTeamIdFilter } from '../permissions/filterHelpers';

import type { DependencyFilters } from './filterSchema';
import type { HydrationOptions } from './hydrationOptions';

export type DependencyPagination = {
  page?: number;
  count?: number;
}

export enum DepthFilterOptions {
  Direct = 'direct',
  Transitive = 'transitive',
}

export enum LayerDepthFilterOptions {
  Base = 'base',
  Other = 'other',
}

export enum HasIssuesFilterOptions {
  HasIssues = 'hasIssues',
  HasLicensingIssues = 'hasLicensingIssues',
  HasQualityIssues = 'hasQualityIssues',
  HasVulnIssues = 'hasVulnIssues',
  NoIssues = 'noIssues',
}

export enum DependencyFilterKeys {
  /**
   * Filter by exact *dependency* locator match.
   */
  Locators = 'locators',
  Title = 'title',
  Status = 'status',
  Depth = 'depth',
  Confidence = 'confidence',
  LayerDepth = 'layerDepth',
  HasIssues = 'hasIssues',
  Licenses = 'licenses',
  Fetchers = 'fetchers',
  ShowIgnored = 'showIgnored',
  RootProjects = 'rootProjects',
  PackageLabels = 'packageLabels',
  /**
   * Filter by locator prefix (since package labels might apply to entire projects).
   * This value is derived from 'packageLabels' and not used directly.
   */
  PackageLocators = 'packageLocators',
  /**
   * Filter by 'vendored', 'managed', or 'snippet'
   * Vendored is only supported on project scope, skipped otherwise
   */
  Sources = 'sources',
  /**
   * Filter by vendoredPath prefix - will filter to vendored depedencies found under this path
   * Only supported on project scope, skipped otherwise
   */
  VendoredPath = 'vendoredPath',
}

export type DependencyQueryWithFilters =
  DependencyFilters & DependencyPagination & HydrationOptions;

export enum ProjectFilterKeys {
  TeamIds = 'teamIds',
}
export type APIProjectFilters = {
  [ProjectFilterKeys.TeamIds]: CommonAPITeamIdFilter;
}

export type ProjectFilters = {
  [ProjectFilterKeys.TeamIds]?: CommonTeamIdFilter;
}
